export const AutomationStageTypeEnum = {
  risk: 'risk',
  client_portal_workflow: 'client_portal_workflow',
  client_portal_default: 'client_portal_default',
  assignment: 'assignment',
  template_activations: 'template_activations',
  control: 'control',
  template_decision_approval: 'template_decision_approval',
  template_decision_rejection: 'template_decision_rejection',
} as const;

export type AutomationStageTypeEnum =
  (typeof AutomationStageTypeEnum)[keyof typeof AutomationStageTypeEnum];
